import React, { useCallback, useMemo } from 'react';
import { CompactPicker } from 'react-color';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ColorEditor(props) {
  const {
    value,
    eventData,
    onChange: pOnChange
  } = props;
  const onChange = useCallback(({
    hex
  }, event) => {
    event.preventDefault();
    pOnChange({
      data: eventData,
      value: hex
    });
  }, [pOnChange, eventData]);
  const styles = useMemo(() => {
    const s = Array.from(document.styleSheets).filter(sheet => sheet.href === null || sheet.href.startsWith(window.location.origin)).reduce((acc, sheet) => {
      return [...acc, ...Array.from(sheet.cssRules).reduce((def, rule) => {
        return rule.selectorText === ':root' ? [...def, ...Array.from(rule.style).filter(name => name.startsWith('--color')).map(name => `var(${name})`)] : def;
      }, [])];
    }, []).filter(name => name.includes('base') || name.includes('brand')).sort((nameA, nameB) => {
      const aIncludesBase = nameA.includes('base');
      const bIncludesBase = nameB.includes('base');
      if (aIncludesBase && bIncludesBase) {
        return nameA > nameB ? 1 : -1;
      }
      if (aIncludesBase) {
        return 1;
      }
      if (bIncludesBase) {
        return -1;
      }
      const aIncludesBrand = nameA.includes('brand');
      const bIncludesBrand = nameB.includes('brand');
      if (aIncludesBrand && bIncludesBrand) {
        return nameA > nameB ? 1 : -1;
      }
      return -1;
    });
    return Array.from(new Set(s)).slice(0, 36).map(color => {
      const div = document.createElement('div');
      div.style = `color: ${color}; display: none;`;
      document.body.appendChild(div);
      const c = window.getComputedStyle(div).color;
      document.body.removeChild(div);
      return c;
    });
  }, []);
  return /*#__PURE__*/_jsx(CompactPicker, {
    colors: styles,
    color: value || '#000000',
    onChange: onChange
  });
}